var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectUiDefinition } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { IdStyles } from "../../less/IdStyles";
import { selectCoop, selectCoopMenuFirstTab, selectCoopSearchSelectedCoop, } from "../../selectors/selectCoopInfo";
import { selectCoopProjectInfo } from "../../selectors/selectCoopProjectInfo";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { componentFromType } from "../generic/componentFromType";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopClearSelectedCoop } from "./actionCoop";
import { IdCoopCategory } from "./IdCoopCategory";
import { IdCoopTabsPositions } from "./IdCoopTabsPositions";
import { MenuCoopFooter } from "./MenuCoopFooter";
export var _MenuCoop = function (_a) {
    var onClose = _a.onClose, selectedTab = _a.selectedTab, selectedCoop = _a.selectedCoop, clearSelectedCoop = _a.clearSelectedCoop, coop = _a.coop, firstTab = _a.firstTab, activeProject = _a.activeProject;
    return (React.createElement(MenuWrapper, { onClose: function () { return onClose(IdModal.Coop); }, type: IdMenuBalancing.CoopMenu, filterTabs: function (tabs) { return getFilteredTabs(tabs, firstTab, activeProject); }, activeTabIndex: selectedTab, modalId: IdModal.Coop, footerRenderer: componentFromType(MenuCoopFooter), lockedTabs: function () { return getLockedTabs(coop); } }));
};
var getLockedTabs = function (coop) {
    if (coop) {
        return [IdCoopCategory.CoopChat];
    }
    return [
        IdCoopCategory.CoopHelp,
        IdCoopCategory.CoopProjects,
        IdCoopCategory.CoopChat,
        IdCoopCategory.CoopMessageBoard,
    ];
};
var getFilteredTabs = function (tabs, firstTab, activeProject) {
    var notAllowedTabs = [];
    switch (firstTab) {
        case IdCoopCategory.CoopFound:
            notAllowedTabs.push(IdCoopCategory.CoopInfoView, IdCoopCategory.CoopEdit);
            break;
        case IdCoopCategory.CoopEdit:
            notAllowedTabs.push(IdCoopCategory.CoopInfoView, IdCoopCategory.CoopFound);
            break;
        case IdCoopCategory.CoopInfoView:
        default:
            notAllowedTabs.push(IdCoopCategory.CoopEdit, IdCoopCategory.CoopFound);
    }
    return tabs
        .filter(function (tab) { return notAllowedTabs.indexOf(tab.id) < 0; })
        .map(function (tab) {
        if (activeProject &&
            activeProject.projectId &&
            tab.id === IdCoopCategory.CoopProjects) {
            return __assign({}, tab, { badge: {
                    children: React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall }),
                    position: IdBadgePosition.TopLeft,
                } });
        }
        return tab;
    });
};
var mapState = function (state) {
    var coop = selectCoop(state);
    var lockedTabs = getLockedTabs(coop);
    var tabs = selectUiDefinition(IdMenuBalancing.CoopMenu).category;
    var activeTabId = selectModalTabId(state, IdModal.Coop);
    var selectedTab = IdCoopTabsPositions.CoopSearch;
    if (tabs != undefined && activeTabId != undefined) {
        selectedTab = tabs
            .filter(function (tab) { return lockedTabs.some(function (tabId) { return tabId !== tab.id; }); })
            .findIndex(function (tab) { return tab.id === activeTabId; });
    }
    return {
        activeProject: selectCoopProjectInfo(state),
        coop: coop,
        firstTab: selectCoopMenuFirstTab(state),
        selectedCoop: selectCoopSearchSelectedCoop(state),
        selectedTab: selectedTab,
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        clearSelectedCoop: actionCoopClearSelectedCoop,
        onClose: actionModalClose,
    }, dispatch);
};
export var MenuCoop = connect(mapState, mapDispatch)(_MenuCoop);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/MenuCoop.tsx
// module id = 2572
// module chunks = 3